export const ACCOUNT_TYPE = Object.freeze({
  SYSTEM: "System",
  SALES: "Sales",
  MSP: "MSP",
  CUSTOMER: "Customer",
});

export default {};
